<mat-drawer-container>
  <mat-drawer
    class="settings-drawer"
    mode="over"
    position="end"
    #drawer
    (closedStart)="updateDrawerState()"
    [opened]="drawerService.state()"
  >
    <div class="drawer-header">
      {{ drawerService.heading }}
      @if (below1k) {
        <button
          class="close-button"
          style="float: right"
          (click)="drawerSvc.closeFilter()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
    <div class="drawer-body">
      @if (drawerService.heading === 'Settings') {
        <lib-user-settings></lib-user-settings>
      } @else if (drawerService.heading === 'Filter(s)') {
        <filter-drawer></filter-drawer>
      }
    </div>
  </mat-drawer>
  <mat-drawer-content>
    @if (spinnerService.spinnerCounter$ | async) {
      <div id="spinner-container">
        <mat-spinner
          diameter="60"
          mode="indeterminate"
          strokeWidth="4"
          color="accent"
        ></mat-spinner>
      </div>
    }

    @if (isMobile) {
      <nav-bar-mobile></nav-bar-mobile>
      <page-content class="page-content-style">
        <router-outlet></router-outlet>
      </page-content>
    } @else {
      <nav-bar>
        <app-page-header></app-page-header>
        <page-content>
          <router-outlet></router-outlet>
        </page-content>
      </nav-bar>
    }
  </mat-drawer-content>
</mat-drawer-container>
